import { Component } from 'vue-property-decorator';
import { Page } from '../../helpers/components';
import { BasePage } from '../base-page';
import { apartmentOverviewData } from './apartments-overview.data';
import { WmsLayout } from '../../components/layout/layout';

@Page(WmsLayout, apartmentOverviewData, (o, n) => o.path != n.path)
@Component
export class ApartmentsOverviewPage extends BasePage {
}

export default ApartmentsOverviewPage;
